/*
* 班牛数据格式化
* 工作表组件格式化、工作表任务格式化、工作表编辑任务数据格式化、工作表新建任务数据格式化
* */
//引入时间处理插件
import moment from 'moment';
//高级筛选中每个组件类型对应的删选类型列表 用于精确查询
export const searchTypeAccurate = {
  1: [
    {title: '等于', id: '1'},
    // {title: '不等于', id: '2'},
    // {title: '包含', id: '3'},
    // {title: '不包含', id: '4'},
    // {title: '包含任一项', id: '5'},
    // {title: '为空', id: '9'},
    // {title: '不为空', id: '10'},
  ],
  2: [
    {title: '范围', id: '8'},
    // {title: '为空', id: '9'},
    // {title: '不为空', id: '10'},
  ],
  3: [
    {title: '包含任一项', id: '5'},
    // {title: '不包含任一项', id: '6'},
    // {title: '为空', id: '9'},
    // {title: '不为空', id: '10'}
  ],
  4: [
    {title: '包含任一项', id: '5'},
    // {title: '不包含任一项', id: '6'},
    // {title: '为空', id: '9'},
    // {title: '不为空', id: '10'}
  ],
  5: [
    {title: '等于', id: '1'},
    // {title: '不等于', id: '2'},
    {title: '包含任一项', id: '5'},
    // {title: '不包含任一项', id: '6'},
    // {title: '包含所有项', id: '7'},
    // {title: '为空', id: '9'},
    // {title: '不为空', id: '10'},
  ],
  6: [
    {title: '等于', id: '1'},
    // {title: '不等于', id: '2'},
    {title: '包含任一项', id: '5'},
    // {title: '不包含任一项', id: '6'},
    // {title: '包含所有项', id: '7'},
    // {title: '为空', id: '9'},
    // {title: '不为空', id: '10'},
    // {title: '重复', id: '15'}
  ],
  7: [
    {title: '范围', id: '8'},
    // {title: '为空', id: '9'},
    // {title: '不为空', id: '10'},
  ],
  8: [
    {title: '范围', id: '8'},
    // {title: '为空', id: '9'},
    // {title: '不为空', id: '10'},
    // {title: '属于', id: '11'},
    // {title: '有交集', id: '12'},
    // {title: '无交集', id: '13'},
  ],
  9: [
    {title: '范围', id: '8'},
    // {title: '为空', id: '9'},
    // {title: '不为空', id: '10'},
  ],
  10: [
    {title: '等于', id: '1'},
    // {title: '不等于', id: '2'},
    // {title: '包含任一项', id: '5'},
    // {title: '不包含任一项', id: '6'},
    // {title: '包含所有项', id: '7'},
    // {title: '为空', id: '9'},
    // {title: '不为空', id: '10'},
  ],
  11: [
    {title: '等于', id: '1'},
    // {title: '不等于', id: '2'},
    // {title: '包含', id: '3'},
    // {title: '不包含', id: '4'},
    // {title: '包含任一项', id: '5'},
    // {title: '不包含任一项', id: '6'},
    // {title: '包含所有项', id: '7'},
    // {title: '范围', id: '8'},
    // {title: '为空', id: '9'},
    // {title: '不为空', id: '10'},
    // {title: '属于', id: '11'},
    // {title: '有交集', id: '12'},
    // {title: '无交集', id: '13'},
  ],
  12: [
    {title: '等于', id: '1'},
    // {title: '不等于', id: '2'},
    // {title: '包含', id: '3'},
    // {title: '不包含', id: '4'},
    // {title: '包含任一项', id: '5'},
    // {title: '不包含任一项', id: '6'},
    // {title: '包含所有项', id: '7'},
    // {title: '范围', id: '8'},
    // {title: '为空', id: '9'},
    // {title: '不为空', id: '10'},
    // {title: '属于', id: '11'},
    // {title: '有交集', id: '12'},
    // {title: '无交集', id: '13'},
  ],
  13: [
    {title: '等于', id: '1'},
    // {title: '不等于', id: '2'},
    // {title: '包含', id: '3'},
    // {title: '不包含', id: '4'},
    // {title: '包含任一项', id: '5'},
    // {title: '不包含任一项', id: '6'},
    // {title: '包含所有项', id: '7'},
    // {title: '范围', id: '8'},
    // {title: '为空', id: '9'},
    // {title: '不为空', id: '10'},
    // {title: '属于', id: '11'},
    // {title: '有交集', id: '12'},
    // {title: '无交集', id: '13'},
  ],
  14: [
    {title: '等于', id: '1'},
    // {title: '为空', id: '9'},
    // {title: '不为空', id: '10'}
  ],
};
//高级筛选中每个组件类型对应的删选类型列表
export const searchTypeMap = {
  1: [
    {title: '等于', id: '1'},
    {title: '不等于', id: '2'},
    {title: '包含', id: '3'},
    {title: '不包含', id: '4'},
    {title: '包含任一项', id: '5'},
    {title: '为空', id: '9'},
    {title: '不为空', id: '10'},
  ],
  2: [
    {title: '范围', id: '8'},
    {title: '为空', id: '9'},
    {title: '不为空', id: '10'},
  ],
  3: [
    {title: '包含任一项', id: '5'},
    {title: '不包含任一项', id: '6'},
    {title: '为空', id: '9'},
    {title: '不为空', id: '10'}
  ],
  4: [
    {title: '包含任一项', id: '5'},
    {title: '不包含任一项', id: '6'},
    {title: '为空', id: '9'},
    {title: '不为空', id: '10'}
  ],
  5: [
    {title: '等于', id: '1'},
    {title: '不等于', id: '2'},
    {title: '包含任一项', id: '5'},
    {title: '不包含任一项', id: '6'},
    {title: '包含所有项', id: '7'},
    {title: '为空', id: '9'},
    {title: '不为空', id: '10'},
  ],
  6: [
    {title: '等于', id: '1'},
    {title: '不等于', id: '2'},
    {title: '包含任一项', id: '5'},
    {title: '不包含任一项', id: '6'},
    {title: '包含所有项', id: '7'},
    {title: '为空', id: '9'},
    {title: '不为空', id: '10'},
    {title: '重复', id: '15'}
  ],
  7: [
    {title: '范围', id: '8'},
    {title: '为空', id: '9'},
    {title: '不为空', id: '10'},
  ],
  8: [
    {title: '范围', id: '8'},
    {title: '为空', id: '9'},
    {title: '不为空', id: '10'},
    {title: '属于', id: '11'},
    {title: '有交集', id: '12'},
    {title: '无交集', id: '13'},
  ],
  9: [
    {title: '范围', id: '8'},
    {title: '为空', id: '9'},
    {title: '不为空', id: '10'},
  ],
  10: [
    {title: '等于', id: '1'},
    {title: '不等于', id: '2'},
    {title: '包含任一项', id: '5'},
    {title: '不包含任一项', id: '6'},
    {title: '包含所有项', id: '7'},
    {title: '为空', id: '9'},
    {title: '不为空', id: '10'},
  ],
  11: [
    {title: '等于', id: '1'},
    {title: '不等于', id: '2'},
    {title: '包含', id: '3'},
    {title: '不包含', id: '4'},
    {title: '包含任一项', id: '5'},
    {title: '不包含任一项', id: '6'},
    {title: '包含所有项', id: '7'},
    {title: '范围', id: '8'},
    {title: '为空', id: '9'},
    {title: '不为空', id: '10'},
    {title: '属于', id: '11'},
    {title: '有交集', id: '12'},
    {title: '无交集', id: '13'},
  ],
  12: [
    {title: '等于', id: '1'},
    {title: '不等于', id: '2'},
    {title: '包含', id: '3'},
    {title: '不包含', id: '4'},
    {title: '包含任一项', id: '5'},
    {title: '不包含任一项', id: '6'},
    {title: '包含所有项', id: '7'},
    {title: '范围', id: '8'},
    {title: '为空', id: '9'},
    {title: '不为空', id: '10'},
    {title: '属于', id: '11'},
    {title: '有交集', id: '12'},
    {title: '无交集', id: '13'},
  ],
  13: [
    {title: '等于', id: '1'},
    {title: '不等于', id: '2'},
    {title: '包含', id: '3'},
    {title: '不包含', id: '4'},
    {title: '包含任一项', id: '5'},
    {title: '不包含任一项', id: '6'},
    {title: '包含所有项', id: '7'},
    {title: '范围', id: '8'},
    {title: '为空', id: '9'},
    {title: '不为空', id: '10'},
    {title: '属于', id: '11'},
    {title: '有交集', id: '12'},
    {title: '无交集', id: '13'},
  ],
  14: [
    {title: '等于', id: '1'},
    {title: '为空', id: '9'},
    {title: '不为空', id: '10'}
  ],
};
//校验子表单的value必填项有没有填写 childrenFormData:子表单组件的完整对象数据 包含条件，包含value值  taskId:通过taskId判断是编辑任务还是新建任务 从而判断子组件是否被禁用
export function checkChildrenFormValue(childrenFormData, taskId) {
  // 校验子表单的value必填
  for (let i in childrenFormData.moduleDefinition) {
    let column = childrenFormData.moduleDefinition[i];
    let disabledComponent = (taskId == '' && column.extraInfo.valueAddable == '1') || (taskId!='' && column.extraInfo.valueEditable == '1');
    let errorMsg = '';
    if (!disabledComponent && column.extraInfo.valueEmptyCheck == '1') {
      for (let c in childrenFormData.value) {
        let flag = false;
        switch (column.behaviorType) {
          case 1: {
            if (!childrenFormData.value[c][column.id] || !childrenFormData.value[c][column.id].value) {
              flag = true;
              errorMsg = childrenFormData.name + ' 的第' + (parseInt(c) + 1) + '条,没有给 ' + column.name + ' 填值';
            }
            break;
          }
          case 2: {
            if (!childrenFormData.value[c][column.id] || (childrenFormData.value[c][column.id].value == '' && childrenFormData.value[c][column.id].value != 0)) {
              flag = true;
              errorMsg = childrenFormData.name + ' 的第' + (parseInt(c) + 1) + '条,没有给 ' + column.name + ' 填写有效数字';
            }
            break;
          }
          case 3:
          case 4: {
            if (!childrenFormData.value[c][column.id] || (!childrenFormData.value[c][column.id].value.id && childrenFormData.value[c][column.id].value.id != 0)) {
              flag = true;
              errorMsg = childrenFormData.name + ' 的第' + (parseInt(c) + 1) + '条, ' + column.name + ' 的选项不能为空';
            }
            break;
          }
          case 5: {
            if (!childrenFormData.value[c][column.id] || childrenFormData.value[c][column.id].value.length == 0) {
              flag = true;
              errorMsg = childrenFormData.name + ' 的第' + (parseInt(c) + 1) + '条, ' + column.name + ' 的选项不能为空';
            }
            break;
          }
        }
        if (flag) {
          break;
        }
      }
      if (errorMsg) {
        return errorMsg;
      }
    }

  }
}

//校验联动组件的value必填项有没有填写 relationData:联动组件的完整对象数据 包含条件，包含value值
export function checkRelationValue(relationData) {
  function checkValue(val, index, list) {
    let level = index;
    if (!val[level] || !val[level].id) {
      return level + 1;
    } else {
      for (let i in list) {
        if (val[level].id == list[i].id) {
          if (list[i].children.length > 0) {
            level++;
            return checkValue(val, level, list[i].children)
          } else {
            return '';
          }
        }
      }
    }
  }

  return checkValue(relationData.value, 0, relationData.moduleDefinition.optionList);
}

//格式化组件 component：需要进行格式化的组件 value:需要json转化的值  key：使用一个字段接受value
function formatComponent(component, key) {
  let data = {error: '', warning: '', ...component};
  switch (data.behaviorType) {
    case 1://文本
    case 2://数值
    case 9://评分
    case 11://富文本
    {
      data.defaultInfo = data.defaultInfo ? data.defaultInfo : '';
      break;
    }
    case 3://单选
    case 4://下拉
    {
      data.defaultInfo = data.defaultInfo ? JSON.parse(data.defaultInfo) : {};
      data.moduleDefinition = data.moduleDefinition ? data.moduleDefinition : [];
      break;
    }
    case 5://多选
    case 10://附件
    {
      data.defaultInfo = data.defaultInfo ? JSON.parse(data.defaultInfo) : [];
      data.moduleDefinition = data.moduleDefinition ? data.moduleDefinition : [];
      break;
    }
    case 6://联动组件
    {
      data.defaultInfo = data.defaultInfo ? JSON.parse(data.defaultInfo) : [];
      data.moduleDefinition = data.moduleDefinition && data.moduleDefinition.header ? data.moduleDefinition : {
        header: [],
        optionList: []
      };
      break;
    }
    case 7://日期
    {
      data.defaultInfo = data.extraInfo.dataExtra && data.extraInfo.dataExtra != '-99' ? moment(new Date().setDate(new Date().getDate() + parseInt(data.extraInfo.dataExtra))).format('YYYY-MM-DD HH:mm:ss') : data.defaultInfo;
      break;
    }
    case 8://日期区间
    {
      let start = '';
      let end = '';
      if (data.extraInfo.dataExtra && data.extraInfo.dataExtra != '0') {
        switch (data.extraInfo.dataExtra) {
          case '1': { //时间取相对日期：今天
            start = moment(new Date().setDate(new Date().getDate())).format('YYYY-MM-DD') + ' 00:00:00';
            end = moment(new Date().setDate(new Date().getDate())).format('YYYY-MM-DD') + ' 23:59:00';
            break;
          }
          case '2': {//时间取相对日期：近7天
            start = moment(new Date().setDate(new Date().getDate())).format('YYYY-MM-DD') + ' 00:00:00';
            end = moment(new Date().setDate(new Date().getDate() + 6)).format('YYYY-MM-DD') + ' 23:59:00';
            break;
          }
          case '3': {//时间取相对日期：近30天
            start = moment(new Date().setDate(new Date().getDate())).format('YYYY-MM-DD') + ' 00:00:00';
            end = moment(new Date().setDate(new Date().getDate() + 29)).format('YYYY-MM-DD') + ' 23:59:00';
            break;
          }
          case '4': {//时间取相对日期：当月
            let nowMonthDays = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate();
            start = moment(new Date().setMonth(new Date().getMonth(), 1)).format('YYYY-MM-DD') + ' 00:00:00';
            end = moment(new Date().setMonth(new Date().getMonth(), nowMonthDays)).format('YYYY-MM-DD') + ' 23:59:00';
            break;
          }
        }
        data.defaultInfo = [start, end];
      } else {
        data.defaultInfo = data.defaultInfo ? JSON.parse(data.defaultInfo) : [];
      }
      break;
    }
    case 13://子表单
    {
      data.defaultInfo = data.defaultInfo ? JSON.parse(data.defaultInfo) : [];
      data.moduleDefinition = data.moduleDefinition ? data.moduleDefinition : [];
      let moduleDefinition = [];
      for (let i in data.moduleDefinition) {
        moduleDefinition.push(formatComponent(data.moduleDefinition[i], key));
      }
      data.moduleDefinition = moduleDefinition;
      break;
    }
    case 14://复合组件 地址
    {
      data.defaultInfo = data.defaultInfo ? JSON.parse(data.defaultInfo) : [{
        id: "",
        behaviorType: 6,
        value: []
      }, {id: "", behaviorType: 1, value: ""}];
      data.moduleDefinition = data.moduleDefinition ? data.moduleDefinition : [];
      break;
    }
    default: {
      data.defaultInfo = !data.defaultInfo ? '' : JSON.parse(data.defaultInfo);
      data.moduleDefinition = data.moduleDefinition ? data.moduleDefinition : [];
    }
  }
  if (key) {
    data[key] = JSON.parse(JSON.stringify(data.defaultInfo))
  }
  return data;
}

//组装高级筛选组件
function installSearchComponent(component, parent) {
  let data = {...component};
  if (parent) {
    data.parentId = parent.id;
    data.name = parent.name + '·' + data.name;
  }
  switch (data.behaviorType) {
    case 1://文本类型
    {
      data.searchType = '1';
      data.value = '';
      break;
    }
    case 2://数值
    case 7://日期
    case 8://日期区间
    case 9://评分
    {
      data.searchType = '8';
      data.value = {start: '', end: ''};
      break;
    }
    case 3://单选
    case 4://下拉
    case 5://多选
    case 6://联动
    {
      data.searchType = '5';
      data.value = [];
      break;
    }
    case 14://复合组件
    {
      data.searchType = '1';
      data.value = [{id: data.moduleDefinition[0].id, behaviorType: 6, value: []}, {
        id: data.moduleDefinition[1].id,
        behaviorType: 1,
        value: ""
      }];
      break;
    }

  }
  return data.searchType ? data : false;
}

//高级筛选格式化组件数据
export function formatComponentForSearch(components, componentValue) {
  let componentList = [];
  let searchValue = [];
  //清空高级筛选可选的组件列表 清空高级筛选所有条件 从父组件传递过来的 searchValue 和 componentList 中还原这两个数据
  searchValue = JSON.parse(JSON.stringify(componentValue));
  components.map(component => {
    if (component.behaviorType == 13) {
      component.moduleDefinition.map(childComponent => {
        let componentData = installSearchComponent(childComponent, component);
        if (componentData) {
          componentList.push(componentData);
          for (let i in searchValue) {
            if (searchValue[i].id == componentData.id) {
              let searchData = {...componentData};
              searchData.value = JSON.parse(searchValue[i].value);
              searchData.searchType = searchValue[i].searchType;
              //当组件是string类型组件，并且筛选条件是包含3、不包含4、包含任一项5,将value的数组换算成字符并回车隔开
              if (searchData.behaviorType == 1 && (searchData.searchType == 3 || searchData.searchType == 4 || searchData.searchType == 5)) {
                searchData.value = searchData.value.join('\n');
              }
              searchValue.splice(i, 1, searchData);
              break;
            }
          }
        }
      })
    } else {
      let componentData = installSearchComponent(component);
      if(!componentData && component.behaviorType == 18){
        componentData = {
          ...component
        }
      }
      if (componentData) {
        componentList.push(componentData);
        for (let i in searchValue) {
          if (searchValue[i].id == componentData.id) {
            let searchData = {...componentData};
            searchData.value = JSON.parse(searchValue[i].value);
            searchData.searchType = searchValue[i].searchType;
            //当组件是string类型组件，并且筛选条件是包含3、不包含4、包含任一项5,将value的数组换算成字符并回车隔开
            if (searchData.behaviorType == 1 && (searchData.searchType == 3 || searchData.searchType == 4 || searchData.searchType == 5)) {
              searchData.value = searchData.value.join('\n');
            }
            searchValue.splice(i, 1, searchData);
            break;
          }
        }
      }
    }
  });
  return {componentList: componentList, searchValue: searchValue}
}

/* 整理组件，初始化组件默认值初始化组件条件格式*/
export function initComponent(components) {
  let componentList = [];
  components.map(component => {
    componentList.push(formatComponent(component))
  })
  return componentList;
}

/* 整理系统组件，初始化组件默认值初始化组件条件格式*/
export function initSystemComponent(components) {
  let componentList = [];
  components.map(classify => {
    let data = {
      classify: classify.classify,
      help: classify.help,
      title: classify.title,
      children: []
    };
    classify.children.map(component => {
      data.children.push(formatComponent(component))
    });
    componentList.push(data)
  });
  return componentList;
}

/* 整理新建任务组件，初始化组件默认值初始化组件条件格式*/
export function initTaskComponent(components, task) {
  let componentList = [];
  if (!task) {
    components.map(component => {
      componentList.push(formatComponent(component, 'value'))
    })
  } else {

  }
  return componentList;
}

/*编辑任务时，根据任务数据对任务组件进行value赋值，然后进行返回*/
export function installEditTaskComponent(components, task) {
  let componentList = []
  components.map(component => {
    let data = {...component};
    if (task[data.id]) {
      data.value = JSON.parse(JSON.stringify(task[data.id].value));
    } else {
      switch (data.behaviorType) {
        case 1://文本
        case 2://数值
        case 7://日期
        case 9://评分
        case 11://富文本
        {
          data.value = '';
          break;
        }
        case 3://单选
        case 4://下拉
        {
          data.value = {};
          data.moduleDefinition = data.moduleDefinition ? data.moduleDefinition : [];
          break;
        }
        case 5://多选
        case 6://联动组件
        case 8://日期区间
        case 10://附件
        case 13://子表单
        {
          data.value = [];
          break;
        }
        case 14://复合组件 地址
        {
          data.value = [{
            id: data.defaultInfo[0] ? data.defaultInfo[0].id : '',
            behaviorType: 6,
            value: []
          }, {id: data.defaultInfo[1] ? data.defaultInfo[1].id : '', behaviorType: 1, value: ""}];
          data.moduleDefinition = data.moduleDefinition ? data.moduleDefinition : [];
          break;
        }
      }
    }
    componentList.push(data)
  })
  return componentList;
}



// WEBPACK FOOTER //
// ./src/util/projectFormatting.js